export default __webpack_public_path__ + "b1ba1b9de8a67515bb765208e69f08a3.jpg";